<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid, reset}" ref="red-flag-modal">
    <artisio-modal :visible="showRedFlagModal"
                   :data="model"
                   :title="$t(`Red Flag Comment`)"
                   :show-confirmation="showConfirmation"
                   :ok-title="$t('Submit')"
                   :is-loading="loading"
                   scrollable
                   @show="onShow"
                   @hidden="onHidden"
                   @ok.prevent="handleSubmit(onSubmit)">
      <input-widget :model="model" attribute="red_flag_comment" type="ckeditor" :label="false"/>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>
  import {createNamespacedHelpers} from 'vuex';
  import ArtisioModal from "../../../../../core/components/artisio-modal/ArtisioModal";
  import RedFlagForm from "../../../models/RedFlagForm.model";
  import InputWidget from "../../../../../core/components/input-widget/InputWidget";

  const {mapState, mapActions} = createNamespacedHelpers('customer/customerView');

  export default {
    name: "RedFlagModal",
    components: {InputWidget, ArtisioModal},
    data: () => {
      return {
        loading: false,
        showConfirmation: true,
        model: new RedFlagForm(),
      }
    },
    methods: {
      ...mapActions(['toggleRedFlagModal', 'saveTermsPartialData']),
      async onSubmit() {
        this.loading = true;
        let response = await this.saveTermsPartialData({red_flag_comment: this.model.red_flag_comment});
        this.loading = false;

        if (response.success) {
          this.onHidden()
          this.$toast('success', this.$t('Red Flag comment was successfully saved'));
        } else {
          if (response.toastError) {
            this.$errorDialog(response.toastError);
          } else {
            this.model.setMultipleErrors(response.body);
          }
        }
      },
      onShow() {
        this.showConfirmation = true;
        this.model = new RedFlagForm({red_flag_comment: this.red_flag_comment});
      },
      onHidden() {
        this.showConfirmation = false;
        this.model = new RedFlagForm();
        this.toggleRedFlagModal(false);
      },
    },
    computed: {
      ...mapState({
        showRedFlagModal: state => state.termsData.showRedFlagModal,
        red_flag_comment: state => state.termsData.red_flag_comment
      }),
    }
  }
</script>

<style lang="scss" scoped>
/deep/ .ck-editor__editable {
  min-height: 150px;
}
</style>